module.exports = __webpack_public_path__ + "img/calendar-28_fill.f74f6707.svg";